import React, { ReactNode } from 'react'
import styled from '@emotion/styled'

type Props = {
  className?: string,
  children: ReactNode
}

const MaxWidthWrapper: React.VFC<Props> = ({ className, children }) => {
  return <Width className={className}>{children}</Width>
}

const Width = styled.div`
  position: relative;
  width: 100%;
  max-width: 1400px;
  margin: auto;
`

export default MaxWidthWrapper
